import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="footer-logo-icon">🪷</span>
              <div>
                <div className="footer-logo-main">Suvaran Maran</div>
                <div className="footer-logo-sub">Matrimony</div>
              </div>
            </div>
            <p className="footer-tagline">
              உங்கள் வாழ்க்கை துணையை கண்டறியுங்கள்<br />
              <em>Find Your Perfect Life Partner</em>
            </p>
            <div className="footer-socials">
              <a href="tel:+91 9842724724" className="footer-contact-item">📞 +919842724724</a>
              <a href="mailto:support@suvaranmaranmatrimony.msdiscoveriescom" className="footer-contact-item">✉️ support@suvaranmaranmatrimony.msdiscoveriescom</a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/plan">Plan & Pricing</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/register">Register Free</Link></li>
              <li><Link to="/login">Member Login</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="footer-col">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms & Conditions</Link></li>
              <li><Link to="/refund">Refund Policy</Link></li>
            </ul>
            <h4 style={{marginTop:'20px'}}>Our Speciality</h4>
            <ul>
              <li>🛡️ Sutham Shield Matching</li>
              <li>⭐ Star Auto Match</li>
              <li>✅ Admin Verified Profiles</li>
              <li>🔒 Contact Privacy System</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>© {new Date().getFullYear()} Suvaran Maran Matrimony. All rights reserved.</p>
          <p>Designed with 🙏 for Tamil Hindu families</p>
        </div>
      </div>
    </footer>
  );
}
